import {
  Layers, BarChart3, Shield, FileText, CheckCircle2,
  Store, Settings, Users,
} from "lucide-react";
import { riskCenterPath } from "../../../utils/riskCenterRoutes";
import { controlsPath } from "../../../utils/controlsRoutes";
import { auditPath } from "../../../utils/auditRoutes";
import { chatPath } from "../../../utils/chatRoutes";
import { thirdPartyPath } from "../../../utils/thirdPartyRoutes";
import { marketplacePath } from "../../../utils/marketplaceRoutes";
import { PiRabbit } from "react-icons/pi";

/**
 * Main app navigation items (Sidebar desktop + mobile drawer).
 * `placement`: "main" | "footer" | "mobileOnly"
 */
export function getMainNavItems(t, role) {
  const isAdmin = role === "Admin";
  const isAuditor = role === "Auditor";

  return [
    {
      to: "/dashboards",
      label: t("sidebar.dashboard"),
      icon: BarChart3,
      placement: "main",
      visible: isAdmin || isAuditor,
    },
    {
      to: riskCenterPath('dashboard'),
      label: t("sidebar.riskCenter"),
      icon: Layers,
      placement: "main",
      visible: true,
      extraPaths: ["/risk_center", "/risk-center"],
    },
    {
      to: controlsPath("dashboard"),
      label: t("sidebar.controls"),
      icon: Shield,
      placement: "main",
      visible: isAdmin,
      extraPaths: ["/controls"],
    },
    {
      to: "/actions",
      label: t("sidebar.actions"),
      icon: CheckCircle2,
      placement: "mobileOnly",
      visible: true,
    },
    {
      to: auditPath("audits"),
      label: t("sidebar.audit"),
      icon: FileText,
      placement: "main",
      visible: isAdmin || isAuditor,
      extraPaths: ["/audit"],
    },
    {
      to: chatPath(),
      label: t("sidebar.askRabo"),
      icon: PiRabbit,
      placement: "main",
      visible: true,
      extraPaths: ["/chat"],
    },
    {
      to: thirdPartyPath("overview"),
      label: t("sidebar.thirdParty"),
      icon: Users,
      placement: "main",
      visible: true,
      extraPaths: ["/third_party"],
    },
    {
      to: marketplacePath("templates"),
      label: t("sidebar.market"),
      icon: Store,
      placement: "main",
      visible: isAdmin,
      extraPaths: ["/marketplace"],
    },
    {
      to: "/admin",
      label: t("sidebar.admin"),
      icon: Settings,
      placement: "footer",
      visible: isAdmin,
    },
  ].filter((item) => item.visible);
}

export function isNavActive(pathname, to, exact = false) {
  if (exact) return pathname === to;
  return pathname === to || pathname.startsWith(`${to}/`);
}
